import featureFlagStore from '@shared/store/featureFlag'

export default function useFeatureFlag() {

  function getFeatureFlag(key) {
    return featureFlagStore.getFlag(key)
  }

  return {
    getFeatureFlag
  }
}
